import { useState, useEffect } from 'react';

export const useAlertData = () => {
  const [alerts, setAlerts] = useState([]);

  useEffect(() => {
    // Generate comprehensive mock alerts for different cameras
    const today = new Date();
    const mockAlerts = [
      // BDI-UP6155-3126-PTR-2 alerts
      {
        id: '1',
        cameraId: 'BDI-UP6155-3126-PTR-2',
        date: today.toISOString().split('T')[0],
        time: '14:00',
        timestamp: `${today.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })} 14:23:45`,
        description: 'Motion detected in restricted area - unauthorized personnel',
        type: 'critical',
        progress: 39.5,
        viewed: false
      },
      {
        id: '2',
        cameraId: 'BDI-UP6155-3126-PTR-2',
        date: today.toISOString().split('T')[0],
        time: '09:00',
        timestamp: `${today.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })} 09:15:30`,
        description: 'Equipment malfunction on conveyor system',
        type: 'warning',
        progress: 25.8,
        viewed: false
      },
      {
        id: '3',
        cameraId: 'BDI-UP6155-3126-PTR-2',
        date: today.toISOString().split('T')[0],
        time: '21:00',
        timestamp: `${today.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })} 21:08:33`,
        description: 'After-hours access detected - security breach',
        type: 'critical',
        progress: 14.2,
        viewed: false
      },

      // BDI-6162-2013-HAMM-ROLLER alerts
      {
        id: '4',
        cameraId: 'BDI-6162-2013-HAMM-ROLLER',
        date: today.toISOString().split('T')[0],
        time: '16:00',
        timestamp: `${today.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })} 16:42:12`,
        description: 'Scheduled maintenance completed successfully',
        type: 'info',
        progress: 70.2,
        viewed: true
      },
      {
        id: '5',
        cameraId: 'BDI-6162-2013-HAMM-ROLLER',
        date: new Date(today.getTime() - 86400000).toISOString().split('T')[0],
        time: '12:00',
        timestamp: `${new Date(today.getTime() - 86400000).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })} 12:33:17`,
        description: 'Fire alarm triggered - false alarm confirmed',
        type: 'critical',
        progress: 55.3,
        viewed: false
      },

      // BDI-UP6162-CHEMICAL-SPREADER alerts
      {
        id: '6',
        cameraId: 'BDI-UP6162-CHEMICAL-SPREADER',
        date: today.toISOString().split('T')[0],
        time: '11:00',
        timestamp: `${today.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })} 11:25:18`,
        description: 'Chemical spill detected in work area',
        type: 'critical',
        progress: 42.3,
        viewed: false
      },
      {
        id: '7',
        cameraId: 'BDI-UP6162-CHEMICAL-SPREADER',
        date: new Date(today.getTime() - 172800000).toISOString().split('T')[0],
        time: '15:00',
        timestamp: `${new Date(today.getTime() - 172800000).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })} 15:55:03`,
        description: 'Emergency exit door left open',
        type: 'critical',
        progress: 91.7,
        viewed: false
      },

      // DRA-UP7234-5521-EXCAVATOR alerts
      {
        id: '8',
        cameraId: 'DRA-UP7234-5521-EXCAVATOR',
        date: today.toISOString().split('T')[0],
        time: '08:00',
        timestamp: `${today.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })} 08:45:22`,
        description: 'Excavator operating outside designated area',
        type: 'warning',
        progress: 75.4,
        viewed: false
      },
      {
        id: '9',
        cameraId: 'DRA-UP7234-5521-EXCAVATOR',
        date: new Date(today.getTime() - 86400000).toISOString().split('T')[0],
        time: '18:00',
        timestamp: `${new Date(today.getTime() - 86400000).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })} 18:12:45`,
        description: 'Heavy machinery maintenance required',
        type: 'warning',
        progress: 21.2,
        viewed: true
      },

      // KDT-UP5567-BULLDOZER-CAT alerts
      {
        id: '10',
        cameraId: 'KDT-UP5567-BULLDOZER-CAT',
        date: new Date(today.getTime() - 259200000).toISOString().split('T')[0],
        time: '13:00',
        timestamp: `${new Date(today.getTime() - 259200000).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })} 13:17:29`,
        description: 'Bulldozer collision with safety barrier',
        type: 'critical',
        progress: 29.1,
        viewed: false
      },

      // GKP-UP4421-GRADER-MOTOR alerts
      {
        id: '11',
        cameraId: 'GKP-UP4421-GRADER-MOTOR',
        date: today.toISOString().split('T')[0],
        time: '07:00',
        timestamp: `${today.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })} 07:15:33`,
        description: 'Motor grader hydraulic system leak detected',
        type: 'warning',
        progress: 25.9,
        viewed: false
      },
      {
        id: '12',
        cameraId: 'GKP-UP4421-GRADER-MOTOR',
        date: new Date(today.getTime() - 345600000).toISOString().split('T')[0],
        time: '17:00',
        timestamp: `${new Date(today.getTime() - 345600000).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })} 17:23:51`,
        description: 'Routine inspection completed',
        type: 'info',
        progress: 39.8,
        viewed: true
      }
    ];

    setAlerts(mockAlerts);
  }, []);

  const getUnviewedAlertsForCamera = (cameraId) => {
    return alerts.filter(alert => alert.cameraId === cameraId && !alert.viewed);
  };

  const getTotalUnviewedAlerts = () => {
    return alerts.filter(alert => !alert.viewed).length;
  };

  const getCriticalUnviewedAlerts = () => {
    return alerts.filter(alert => !alert.viewed && alert.type === 'critical').length;
  };

  const markAlertAsViewed = (alertId) => {
    setAlerts(prev => prev.map(alert =>
      alert.id === alertId ? { ...alert, viewed: true } : alert
    ));
  };

  const markCameraAlertsAsViewed = (cameraId) => {
    setAlerts(prev => prev.map(alert =>
      alert.cameraId === cameraId ? { ...alert, viewed: true } : alert
    ));
  };

  return {
    alerts,
    getUnviewedAlertsForCamera,
    getTotalUnviewedAlerts,
    getCriticalUnviewedAlerts,
    markAlertAsViewed,
    markCameraAlertsAsViewed
  };
};